import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class Application extends Route {
  @service head;
  @service metrics;
  @service router;
  @service currentUser;

  constructor() {
    super(...arguments);

    this.metrics.trackViews();

    this.router.on('routeDidChange', () => {
      const page = this.router.currentURL;
      const title = this.router.currentRouteName || 'unknown';

      this.metrics.track('$pageview', { page, title });
    });
  }

  // Global error handling
  error(error, transition) {
    // Capture route errors with PostHog
    this.metrics.captureRouteError(
      transition.targetName || 'unknown-route',
      error,
      {
        url: transition.intent.url,
        params: transition.params,
        queryParams: transition.queryParams,
      }
    );

    // Don't bubble the error, show a user-friendly message instead
    return true;
  }

  afterModel() {
    this.head.updateMeta({
      title: '1vX.gg',
      description: 'The Best Way To Watch eSports.',
      ogTitle: '1vX.gg',
      ogDescription: 'The Best Way To Watch eSports.',
      ogImage: 'https://images.ctfassets.net/g4p7iq2vydf4/2VYmtDpsYdXCQLgbqgallM/234186ae8459a9bacfba5d99b5af88a9/logo.png',
      ogType: 'website',
      canonical: 'https://1vx.gg/'
    });
  }

  @action
  loading(transition, originRoute) {
    // Track loading events for analytics
    const routeName = transition.targetName || 'unknown';
    const startTime = Date.now();
    
    this.metrics.track('route_loading_start', {
      route: routeName,
      url: transition.intent.url,
      timestamp: startTime
    });

    // Set up completion tracking
    transition.promise
      .finally(() => {
        const loadTime = Date.now() - startTime;
        this.metrics.track('route_loading_complete', {
          route: routeName,
          url: transition.intent.url,
          loadTime,
          timestamp: Date.now()
        });
      })
      .catch((error) => {
        // Already handled by the error action, but track loading failure
        this.metrics.track('route_loading_failed', {
          route: routeName,
          url: transition.intent.url,
          error: error.message,
          timestamp: Date.now()
        });
      });

    // Return true to allow the loading template to be shown
    return true;
  }
}
